<template>
  <form @submit.prevent="send">
    <BackButton link="/agency/find-partners" text="Back to Find partners" />
    <div class="dashboard-title mb-xs">
      <div class="dashboard-title__actions">
        <div>
          <h1 class="fw-bold fs-xl mb-xs">Invite Integration Partner</h1>
          <p class="fc-darker fs-md mr-lg">
            Invite partners to join your integration directory.
          </p>
        </div>
        <Button type="submit">
          Send invitations
        </Button>
      </div>
    </div>
    <hr class="mb-lg" />
    <div class="grid grid--rev">
      <div class="grid__cell col5-of-12--large-up"></div>
      <div class="grid__cell col7-of-12--large-up">
        <div>
          <label class="is-required">
            Partner Name
            <input
              data-hj-allow
              v-model="agencyTechPartnerCompanyName"
              type="text"
              placeholder="Acme, Inc"
              required
            />
          </label>
          <label class="is-required">
            Name
            <input
              data-hj-allow
              v-model="agencyTechPartnerContactName"
              type="text"
              required
              placeholder="John Doe"
            />
          </label>
          <label class="is-required">
            Email
            <input
              v-model="agencyTechPartnerContactEmail"
              type="email"
              placeholder="jdoe@example.com"
              required
            />
          </label>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Button from '@/components/DesignSystem/Button';
import BackButton from '@/components/BackButton';
const { mapActions } = createNamespacedHelpers('sendInvitations');

export default {
  components: {
    Button,
    BackButton,
  },
  data() {
    return {
      agencyTechPartnerCompanyName: '',
      agencyTechPartnerContactName: '',
      agencyTechPartnerContactEmail: '',
    };
  },
  methods: {
    ...mapActions(['sendInvitation']),
    async send() {
      const res = await this.sendInvitation({
        agencyTechPartnerCompanyName: this.agencyTechPartnerCompanyName,
        agencyTechPartnerContactName: this.agencyTechPartnerContactName,
        agencyTechPartnerContactEmail: this.agencyTechPartnerContactEmail,
      });
      if (res) this.$router.push('/agency/our-directory/manage-partners');
    },
  },
};
</script>
